import { useQuery } from '@tanstack/react-query';
import type { ColumnSort } from '@tanstack/react-table';

import { DEFAULT_ROSTER_PAGE_SIZE } from '~/modules/artist-roster/constants';
// @TODO WMG1-574 - Extract duplicated types to a higher level so that we don't have these huge imports.
import type {
  TrackReleaseType,
  TrackRoleType,
} from '~/modules/artist-roster/pages/artist-details/utils/types';

import { getArtistTracks } from '../lib/tracks';
import { formatArtistTracksSortBy } from '../utils/formatArtistTracksSortBy';
import { formatContributorRole } from '../utils/formatContributorRole';
import { formatReleaseDate } from '../utils/formatReleaseDate';

interface ArtistTracksQueryProps {
  uaid?: number | null;
  columnSort?: ColumnSort;
  pageNumber: number;
  searchText?: string;
  releaseType?: TrackReleaseType;
  limit?: number;
  isReleased?: boolean;
  role?: TrackRoleType;
}

export function useArtistTracksQuery({
  uaid,
  columnSort,
  pageNumber,
  searchText,
  releaseType,
  limit = DEFAULT_ROSTER_PAGE_SIZE,
  isReleased,
  role,
}: ArtistTracksQueryProps) {
  return useQuery({
    enabled: !!uaid,
    queryKey: [
      'artist-tracks',
      uaid,
      pageNumber,
      columnSort?.id,
      columnSort?.desc,
      releaseType,
      searchText,
      limit,
      isReleased,
      role,
    ],
    queryFn: ({ signal }) => {
      const sortBy = formatArtistTracksSortBy(columnSort);
      const { startDate, endDate } = formatReleaseDate(releaseType);
      const contributorType = formatContributorRole(role);

      return getArtistTracks({
        offset: (pageNumber - 1) * limit,
        limit,
        uaid,
        sortBy,
        startDate,
        endDate,
        searchText,
        isReleased,
        contributorType,
        signal,
      });
    },
  });
}
